__turbopack_context__.v({
  "aCount": "dpXWlq_aCount",
  "aOngoing": "dpXWlq_aOngoing",
  "aSoon": "dpXWlq_aSoon",
  "aTally": "dpXWlq_aTally",
  "aValidated": "dpXWlq_aValidated",
  "areaButton": "dpXWlq_areaButton",
  "areaColumnHead": "dpXWlq_areaColumnHead",
  "areaDot": "dpXWlq_areaDot",
  "areaName": "dpXWlq_areaName",
  "barTop": "dpXWlq_barTop",
  "cFig": "dpXWlq_cFig",
  "cGo": "dpXWlq_cGo",
  "cN": "dpXWlq_cN",
  "cRef": "dpXWlq_cRef",
  "cSen": "dpXWlq_cSen",
  "cStudy": "dpXWlq_cStudy",
  "chip": "dpXWlq_chip",
  "chips": "dpXWlq_chips",
  "closeBtn": "dpXWlq_closeBtn",
  "columnHead": "dpXWlq_columnHead",
  "context": "dpXWlq_context",
  "contextBar": "dpXWlq_contextBar",
  "contextDot": "dpXWlq_contextDot",
  "contextLabel": "dpXWlq_contextLabel",
  "figLabel": "dpXWlq_figLabel",
  "figNum": "dpXWlq_figNum",
  "flag": "dpXWlq_flag",
  "flagDot": "dpXWlq_flagDot",
  "frame": "dpXWlq_frame",
  "heading": "dpXWlq_heading",
  "inner": "dpXWlq_inner",
  "ledgerIndex": "dpXWlq_ledgerIndex",
  "list": "dpXWlq_list",
  "moreBtn": "dpXWlq_moreBtn",
  "moreRow": "dpXWlq_moreRow",
  "name": "dpXWlq_name",
  "panel": "dpXWlq_panel",
  "panelBody": "dpXWlq_panelBody",
  "panelCount": "dpXWlq_panelCount",
  "panelHead": "dpXWlq_panelHead",
  "panelTitle": "dpXWlq_panelTitle",
  "panelToggle": "dpXWlq_panelToggle",
  "pickerBox": "dpXWlq_pickerBox",
  "pickerChevron": "dpXWlq_pickerChevron",
  "pickerCount": "dpXWlq_pickerCount",
  "pickerDot": "dpXWlq_pickerDot",
  "pickerHead": "dpXWlq_pickerHead",
  "pickerLabel": "dpXWlq_pickerLabel",
  "pickerList": "dpXWlq_pickerList",
  "pickerRow": "dpXWlq_pickerRow",
  "pickerScrim": "dpXWlq_pickerScrim",
  "pickerTitle": "dpXWlq_pickerTitle",
  "progress": "dpXWlq_progress",
  "rowLink": "dpXWlq_rowLink",
  "rowStatic": "dpXWlq_rowStatic",
  "scrim": "dpXWlq_scrim",
  "section": "dpXWlq_section",
  "seg": "dpXWlq_seg",
  "sen": "dpXWlq_sen",
  "senDot": "dpXWlq_senDot",
  "sensors": "dpXWlq_sensors",
  "sub": "dpXWlq_sub",
  "toggle": "dpXWlq_toggle",
});
